import { render } from "./index.vue?vue&type=template&id=30a6cb75&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.scss?vue&type=style&index=0&id=30a6cb75&lang=scss&scoped=true"

import exportComponent from "/Users/yue/Documents/其他项目/数字转创/official-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30a6cb75"]])

export default __exports__